import { createSlice } from '@reduxjs/toolkit';
import { PANEL_DETAIL_DEFAULTS } from '../config/panelDetailConfig/defaults';

const initialState = {
  // Global varsayilan ayarlar
  defaults: { ...PANEL_DETAIL_DEFAULTS },

  // Pano instance'lari
  panels: {},
};

const panelDetailSlice = createSlice({
  name: 'panelDetail',
  initialState,
  reducers: {
    // Varsayilan ayarlari guncelle
    updateDefaults: (state, action) => {
      const { section, changes } = action.payload;
      // section: 'meter' | 'meterCompartment' | 'busbarCompartment' | 'distributionCompartment' | 'dimensions' | 'views' | 'frame'
      if (section === 'meter') {
        // meter has nested phase3/phase1
        if (changes.phase3) {
          Object.assign(state.defaults.meter.phase3, changes.phase3);
        }
        if (changes.phase1) {
          Object.assign(state.defaults.meter.phase1, changes.phase1);
        }
      } else if (section === 'dimensions' && (changes.positions || changes.doorPositions)) {
        // dimensions.positions / doorPositions nested guncelleme
        if (changes.positions) {
          Object.assign(state.defaults.dimensions.positions, changes.positions);
        }
        if (changes.doorPositions) {
          Object.assign(state.defaults.dimensions.doorPositions, changes.doorPositions);
        }
        const { positions, doorPositions, ...rest } = changes;
        if (Object.keys(rest).length > 0) {
          Object.assign(state.defaults.dimensions, rest);
        }
      } else if (section === 'distributionCompartment' && changes.aos !== undefined) {
        // distributionCompartment.aos nested guncelleme
        state.defaults.distributionCompartment.aos = changes.aos;
        const { aos, ...rest } = changes;
        if (Object.keys(rest).length > 0) {
          Object.assign(state.defaults.distributionCompartment, rest);
        }
      } else if (state.defaults[section]) {
        Object.assign(state.defaults[section], changes);
      }
    },

    // Pano instance olustur
    createPanel: (state, action) => {
      const { id, panelTypeId, label, meters = [] } = action.payload;
      state.panels[id] = {
        id,
        panelTypeId,
        label,
        meters,
        overrides: {
          meterCompartment: {},
          busbarCompartment: {},
          distributionCompartment: {},
          dimensions: null,
        },
        computed: {},
      };
    },

    // Pano instance'ina sayac ekle/cikar
    updatePanelMeters: (state, action) => {
      const { panelId, meters } = action.payload;
      if (state.panels[panelId]) {
        state.panels[panelId].meters = meters;
      }
    },

    // Pano override ayarlarini guncelle
    updatePanelOverrides: (state, action) => {
      const { panelId, section, changes } = action.payload;
      if (state.panels[panelId] && state.panels[panelId].overrides[section]) {
        Object.assign(state.panels[panelId].overrides[section], changes);
      }
    },

    // Hesaplanan boyutlari guncelle
    updateComputedSizes: (state, action) => {
      const { panelId, computed } = action.payload;
      if (state.panels[panelId]) {
        state.panels[panelId].computed = computed;
      }
    },

    // Pano sil
    removePanel: (state, action) => {
      delete state.panels[action.payload];
    },

    // Varsayilanlara don
    resetDefaults: (state) => {
      state.defaults = { ...PANEL_DETAIL_DEFAULTS };
    },
  },
});

export const {
  updateDefaults,
  createPanel,
  updatePanelMeters,
  updatePanelOverrides,
  updateComputedSizes,
  removePanel,
  resetDefaults,
} = panelDetailSlice.actions;

// Selectors
export const selectPanelDetailDefaults = (state) => state.panelDetail.defaults;
export const selectPanelDetailPanels = (state) => state.panelDetail.panels;
export const selectPanelDetailById = (panelId) => (state) => state.panelDetail.panels[panelId];
export const selectMeterDefaults = (state) => state.panelDetail.defaults.meter;
export const selectFrameDefaults = (state) => state.panelDetail.defaults.frame;
export const selectBusbarDefaults = (state) => state.panelDetail.defaults.busbarCompartment;
export const selectDistributionDefaults = (state) => state.panelDetail.defaults.distributionCompartment;
export const selectDimensionDefaults = (state) => state.panelDetail.defaults.dimensions;
export const selectViewDefaults = (state) => state.panelDetail.defaults.views;
export const selectMeterCompartmentDefaults = (state) => state.panelDetail.defaults.meterCompartment;
export const selectAosDefaults = (state) => state.panelDetail.defaults.distributionCompartment.aos;

export default panelDetailSlice.reducer;
